import React, {useEffect, useRef, useState} from 'react';
import {FileUpload} from "primereact/fileupload";
import Identification from "../tabs/identification";
import ProjectBoard from "../tabs/project-board";
import Tasks from "../tabs/tasks";
import Schedule from "../tabs/schedule";
import Calendar from "../tabs/calendar";
import Message from "../tabs/message";
import Files from "../tabs/files";
import {StepperPanel} from "primereact/stepperpanel";
import {Button} from "primereact/button";
import {Stepper} from "primereact/stepper";
import {useTranslate} from "../../../system/useTranslate";
import {DataView} from "primereact/dataview";
import {Dropdown} from "primereact/dropdown";
import Icon from "../../../system/components/icon";
import Table from "../../../system/components/table";
import {useTask} from "../../../models/task/use-task";
import {useDispatch, useSelector} from "react-redux";
import {setMessage} from "../../../system/app-slice";
import {DateObject} from "react-multi-date-picker";
import {fileThumbnail, toDateObject} from "../../../system/utils";
import {FileIcon} from "react-file-icon";
import {usePermission} from "../../../system/usePermission";

export function formatExportDate(value) {
    const date = value ? new Date(value) : null;
    if (!date || !Number.isFinite(date.getTime()) || date.getUTCFullYear() <= 1971) return "";
    return new Intl.DateTimeFormat("fa-IR-u-ca-persian", {year: "numeric", month: "2-digit", day: "2-digit"}).format(date);
}

function safeFileName(value) {
    return String(value || "zofino").replace(/[\\/:*?"<>|]+/g, "-").trim();
}

function ImportExcelTasks({projectData, tasks = [], createBatchTasks}) {
    const [importedData, setImportedData] = useState([]);
    const [file, setFile] = useState();
    const [modifiedImportedData, setModifiedImportedData] = useState([]);
    const [importedCols, setImportedCols] = useState([{ field: '', header: 'Header' }]);
    const [exchangedFields, setExchangedFields] = useState();
    const [loading, setLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0)
    const translate = useTranslate();
    const permission = usePermission();

    const stepperRef = useRef();
    const steps = [
        { id: "load-file", label: "load-file", icon: "mi mi:upload_file", view:ChooseFile },
        { id: "reset-columns", label: "reset-columns", icon: "mi mi:rebase", view:ResetColumns },
        { id: "preview", label: "preview", icon: "mi mi:preview", view:Preview }
    ];

    useEffect(() => {
        if (projectData){
            permission.setScopeId(projectData.documentId);
            permission.setScopeRolePermissions(projectData?.rolesConfig);
        }
    }, [projectData]);

    useEffect(() => {
        // console.log(modifiedImportedData)
    }, [modifiedImportedData]);

    const submit = async ()=>{
        setLoading(true);

        await createBatchTasks(modifiedImportedData, file?.name);
        setLoading(false);
        setImportedCols(undefined);
        setImportedData(undefined);
        setModifiedImportedData(undefined);
        setExchangedFields(undefined);
        setFile(undefined);
        setActiveIndex(0);
    }
    const ActiveStep = steps[activeIndex].view

    const exportProjectTasks = async () => {
        const xlsx = await import("xlsx");
        const rows = (Array.isArray(tasks) ? tasks : []).map((task) => ({
            [translate("task-title")]: task?.title || "",
            [translate("task-description")]: task?.description || "",
            [translate("assignee")]: task?.assignee?.member?.fullname || "",
            [translate("phone-number")]: task?.assignee?.member?.phonenumber || "",
            [translate("startAt")]: formatExportDate(task?.startAt),
            [translate("dueDate")]: formatExportDate(task?.dueDate),
            [translate("status")]: translate(task?.taskStatus || "todo"),
            [translate("deliverable")]: (task?.deliverables || []).map((item) => item?.title).filter(Boolean).join("، "),
        }));
        const worksheet = xlsx.utils.json_to_sheet(rows.length ? rows : [{[translate("task-title")]: ""}]);
        worksheet["!cols"] = [{wch: 34}, {wch: 45}, {wch: 24}, {wch: 20}, {wch: 18}, {wch: 18}, {wch: 18}, {wch: 28}];
        const workbook = xlsx.utils.book_new();
        xlsx.utils.book_append_sheet(workbook, worksheet, translate("tasks"));
        xlsx.writeFile(workbook, `${safeFileName(projectData?.title || translate("project"))}-${translate("tasks")}.xlsx`);
    };

    return (
        <div className="h-full overflow-auto">

            <div className="w-full flex flex-column align-items-center justify-content-center h-full">
                <div className="w-8 flex flex-column gap-3">
                    <div className="flex justify-content-end">
                        <Button type="button" outlined icon="pi pi-file-export" className="text-xs gap-2"
                                label={translate("export-project-tasks")} onClick={exportProjectTasks}/>
                    </div>
                    <div className="p-2 border-round-xl border-1 border-300 border-dashed">
                    <Stepper linear activeStep={activeIndex} ref={stepperRef} onChangeStep={(e)=>{setActiveIndex(e.index)}}>
                        {
                            steps.map((step, index)=>(
                                <StepperPanel key={step.id} pt={{title:()=>({className:"text-xs"})}} header={translate(step.label)}>
                                    <div className="flex flex-column h-18rem">
                                        <ActiveStep loading={loading} setLoading={setLoading} file={file} setFile={setFile} projectData={projectData} exchanged={exchangedFields} setExchanged={setExchangedFields} modifiedImportedData={modifiedImportedData} setModifiedImportedData={setModifiedImportedData} importedCols={importedCols} setImportedCols={setImportedCols} importedData={importedData} setImportedData={setImportedData} />
                                    </div>
                                    <div className="flex py-2  gap-2 w-full justify-content-between">
                                        {index>0&&<Button className="text-xs gap-1" label={translate("previous")} severity="secondary" icon="pi pi-arrow-right text-xs mx-0" iconPos="left" onClick={() => stepperRef.current.prevCallback()} />}
                                        {activeIndex<steps.length-1&&<Button disabled={!file} className="text-xs gap-1" label={translate("confirm-continue")} icon="pi pi-arrow-left text-xs mx-0" iconPos="right" onClick={() => stepperRef.current.nextCallback()} />}
                                        {activeIndex===steps.length-1&&<Button disabled={!modifiedImportedData||modifiedImportedData?.length===0} loading={loading} className="text-xs gap-2 p-button-success" label={translate("confirm-submit")} icon="pi pi-upload text-xs mx-0" iconPos="right" onClick={() => {submit()}} />}
                                    </div>
                                </StepperPanel>
                            ))
                        }
                    </Stepper>
                    </div>
                </div>
            </div>

        </div>
    );
}

function ChooseFile({setImportedData, setImportedCols, setExchanged, setFile, file}) {
    const translate = useTranslate();
    const ref = useRef();
    const handleDropFile = (e) => {
        e.preventDefault();

        const _file = e.dataTransfer.files?.[0];
        setExchanged(undefined);
        if (_file){
            setFile(_file);
            importExcel(_file)
        }
    };

    const handleChooseFile=(e)=>{
        // console.log(e)
        setExchanged(undefined);
        const _file = e.target.files?.[0];

        if (_file){
            setFile(_file);
            importExcel(_file)
        }

        // ref?.current?.clear();
    }

    const importExcel = (file) => {
        import('xlsx').then(xlsx => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const wb = xlsx.read(e.target.result, { type: 'array' });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = xlsx.utils.sheet_to_json(ws, { header: 1 });

                // Prepare DataTable
                const cols = data[0];
                data.shift();

                let _importedCols = cols.map(col => ({ field: col, header: col }));
                let _importedData = data.map(d => {
                    return cols.reduce((obj, c, i) => {
                        obj[c] = d[i];
                        return obj;
                    }, {});
                });

                setImportedCols(_importedCols);
                setImportedData(_importedData);
            };

            reader.readAsArrayBuffer(file);

        });
    }


    return(
        <div className="flex flex-column gap-2 h-full">
            <div className="flex p-3 border-1 border-round-xl bg-primary-50 border-primary-100 justify-content-between align-items-center">
                <div className="flex align-items-center text-xs gap-2">
                    <div className="p-2 shadow-2 bg-white border-round-xl p-3 flex align-items-center justify-content-center"><Icon icon="mi mi:description" className="text-3xl text-primary"/></div>
                    <div className="flex flex-column gap-2">
                        <span className="font-bold">{translate("no-file-yet")}</span>
                        <span className="text-400">{translate("no-file-yet-description")}</span>
                    </div>

                </div>
                <Button type="button" onClick={() => {
                    const anchor = document.createElement("a");
                    anchor.href = `${process.env.PUBLIC_URL || ""}/task-import-template.xlsx`;
                    anchor.download = "zofino-task-import-template.xlsx";
                    anchor.click();
                }} className="p-button-success p-2 px-3 text-xs h-fit gap-2" icon="pi pi-file-excel mr-0" label={translate("download-template-excel")}/>
            </div>
            <input
                ref={ref}
                type="file"
                accept=".xlsx,.xls,.csv"
                hidden
                onChange={handleChooseFile}
            />
            <div onDrop={handleDropFile} onDragOver={(e) => e.preventDefault()} className="border-2 flex-1 gap-2 border-dashed surface-border border-round surface-ground flex-auto flex flex-column justify-content-center align-items-center font-medium h-full">
                {/*<FileUpload ref={ref} chooseOptions={{ label: 'Excel', icon: 'pi pi-file-excel', className: 'p-button-success',  }} mode="basic" name="demo[]" auto className="mr-2" customUpload uploadHandler={importExcel} />*/}
                {
                    file?(
                        <div className="flex align-items-center gap-1 surface-100 border-round-lg border-1 border-200 p-2 z-1">
                            <Icon icon="mi mi:delete" className="text-red-500 z-5" onClick={(e)=>{e.preventDefault(); setFile?.(undefined); setExchanged(undefined)}}/>
                            {file?.name}
                            {fileThumbnail(file?.name, file, "3rem")}

                        </div>
                    ):(
                        <div onClick={() => ref.current?.click()} className="cursor-pointer flex flex-column gap-2 align-items-center justify-content-center">
                            <div className="flex align-items-center bg-white justify-content-center p-4 shadow-1 border-round-xl">
                                <Icon icon="mi mi:cloud_upload"/>
                            </div>
                            <span className="font-bold text-400">{translate("drop-excel-file-hear")}</span>
                            <span className="text-xs text-400">{translate("or-click-to-choose-excel-file")}</span>
                            <span className="text-3xs text-400">{translate("drop-excel-file-hear-description")}</span>
                        </div>
                    )
                }
            </div>
        </div>
    )
}
function ResetColumns({importedData, importedCols, setModifiedImportedData, exchanged, setExchanged, projectData}) {
    const translate = useTranslate();

    const buildImportedData = (_exchanged) => {
        let result = importedData.map(row =>
            Object.entries(_exchanged).reduce((obj, [oldKey, newKey]) => {

                let value = row[oldKey];

                const option = options.find(o => o.value === newKey);

                if (option?.rules === "project-member") {
                    const member = projectData.members.find(
                        m => m.member.phonenumber === value
                    );

                    value = member?.member || null;
                }
                if (option?.rules === "persian-datetime") {
                    const datetime = toDateObject(value)

                    value = datetime.toDate() || null;
                }

                obj[newKey] = value;

                return obj;
            }, {})
        );

        return result.filter(item=>item.title!==undefined);
    };

    const modifyFields = (data, e) => {
        const _exchanged = {
            ...exchanged,
            [data.field]: e.value
        };

        setExchanged(_exchanged);
        setModifiedImportedData(buildImportedData(_exchanged));
    };

    const removeField = (fieldName) => {
        const { [fieldName]: removed, ...rest } = exchanged;

        setExchanged(rest);
        setModifiedImportedData(buildImportedData(rest));
    };

    let options = [
            {label:"title", value:"title", disabled:Object.values(exchanged||{}).includes("title"), rules:"text"},
            {label:"task-description", value:"description", disabled:Object.values(exchanged||{}).includes("description"), rules:"text"},
            {label:"assignee", value:"assignee", disabled:Object.values(exchanged||{}).includes("assignee"), rules:"project-member"},
            {label:"dueDate", value:"dueDate", disabled:Object.values(exchanged||{}).includes("dueDate"), rules:"persian-datetime"},
        ]

    const ItemTemplate = (data)=>{
        return(
            <div className="w-full p-1">
                <div className="surface-100 p-2 px-3 border-round flex justify-content-between align-items-center">
                    <div className="w-3 text-xs">
                        {data.field}
                    </div>
                    <Icon icon="mi mi:arrow_circle_left"/>
                    <div className="flex align-items-center gap-1 w-4">

                        <Dropdown placeholder={`${translate("exchange-to")} ...`} key={data.field} value={exchanged?.[data.field]} onChange={(e)=>{modifyFields(data, e)}} options={options} itemTemplate={(option)=>(<div className="text-xs">{translate(option.label)}</div>)} valueTemplate={(option, props)=>{return option?<div className="text-xs">{translate(option?.label)}</div>:<div className="text-xs">{props.placeholder}</div>}} className="w-full"/>
                        <Icon icon="mi mi:delete" className="text-red-500" onClick={()=>{removeField(data.field)}}/>
                    </div>
                </div>
            </div>
        )
    }
    return(
        <div className="h-full overflow-auto w-full scrollbar-hide">
            <DataView value={importedCols} layout="list" itemTemplate={ItemTemplate}/>
        </div>
    )
}
function Preview({modifiedImportedData}) {


    const fieldsConfig = {
        description:{alias:"task-description"},
        dueDate:{type:"PERSIAN_DATE"},
        assignee:{type:"ACTIONS", className: "flex-1 flex justify-content-start", value:(item)=>(<div className="w-full text-right">{item?.assignee?.member?.fullname}</div>)}
    }
    return(
        <div className="h-full overflow-auto w-full scrollbar-hide">
            <Table value={modifiedImportedData} fieldsConfig={fieldsConfig} style={null} showFooter={false} showHeader={false}/>
        </div>
    )
}

export default ImportExcelTasks;
